// extracted by mini-css-extract-plugin
export default {"item":"Item_item__7nQ+e","itemSelecionado":"Item_itemSelecionado__7HZPb","itemCompletado":"Item_itemCompletado__dUNzt","concluido":"Item_concluido__6lZvW"};